module.exports = __webpack_public_path__ + "img/productos.6811ad2a.png";